export default {
  presenter: 'koci',
  title: 'Domáci Wifi síť s OpenWRT',
  subtitle: 'začátečníci',
  text: `
OpenWRT je systém pro síťové prvky který podporuje velký počet zařízení a je tak pravděpodobné,
že váš starý wifi router který jste vyřadili může znovu ožít s tímto systémem. Z takovéhoto zařízení
se pak snadno může stát AP (access point) kterým pokryjete i nejzazší kouty domácnosti.  
Ukážeme si jak nastavit několik routerů do jedné sítě, kde jeden plní roli routeru a ostatní přístupového
bodu. Dále si pak ukážeme jak takovou síť rozšířit o Wifi pro hosty. To vše pomocí webového rozhraní Luci
a přímo na přednášce.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/koci-wifi.js